import { render, staticRenderFns } from "./MercadoFechado.vue?vue&type=template&id=68f0b217&scoped=true"
import script from "./MercadoFechado.vue?vue&type=script&lang=js"
export * from "./MercadoFechado.vue?vue&type=script&lang=js"
import style0 from "./MercadoFechado.vue?vue&type=style&index=0&id=68f0b217&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f0b217",
  null
  
)

export default component.exports